import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "TooltipDimple.svg",
  "use": "TooltipDimple.svg-usage",
  "viewBox": "0 0 12 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 32\" id=\"TooltipDimple.svg\">\n    <path d=\"M9.175 20.651C3.058 24.349 0 28.132 0 32V0c0 3.821 2.985 7.368 8.955 10.642 2.878 1.578 3.896 5.127 2.272 7.926a5.893 5.893 0 0 1-2.052 2.083z\" fill=\"#101820\" fillRule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol